define.alias("shared/components/shared/media-items/media-item-video", "settings/components/shared/media-items/media-item-video");